import {ChangeDetectionStrategy, Component, computed, Injectable, Signal} from "@angular/core";
import {toSignal} from "@angular/core/rxjs-interop";
import {TranslateModule} from "@ngx-translate/core";
import {Observable} from "rxjs";
import {GruppeDatatjeneste, GruppeModellDML} from "felles-ng2/tjenester/datalager/GruppeDatatjeneste";
import {alleGrupperMedType} from "felles-ng2/modell/gruppeModellHjelpere";
import {InvitasjonerDatatjeneste} from "felles-ng2/tjenester/datalager/InvitasjonerDatatjeneste";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {KortSamlingKomponent} from "web-ng2/delt/komponenter/kort/kort-samling/kort-samling";
import {KortSamlingOverskriftKomponent} from "web-ng2/delt/komponenter/kort/kort-samling-overskrift/kort-samling-overskrift";
import {GruppeInvitasjonTilGodkjenningModell, GruppeModell, Gruppetype} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {GruppeKortKomponent} from "../gruppe-kort/gruppe-kort";
import {GruppeInvitasjonKortKomponent} from "web-ng2/moduler/gruppe/komponenter/gruppe-invitasjon-kort/gruppe-invitasjon-kort";
import {GruppeNyKomponent} from "web-ng2/moduler/gruppe/komponenter/gruppe-ny/gruppe-ny";
import {Navigasjon} from "web-ng2/tjenester/Navigasjon";

const debug = initDebugger('GrupperVisKomponent');

@Component({
    selector: 'grupper-vis',
    templateUrl: 'grupper-vis.html',
    styleUrl: 'grupper-vis.scss',
    imports: [
        TranslateModule,
        KortSamlingKomponent,
        KortSamlingOverskriftKomponent,
        GruppeKortKomponent,
        GruppeInvitasjonKortKomponent,
        GruppeNyKomponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GrupperVisKomponent {
    static ajsSelector = 'grupperVis';

    ordinaere: Signal<GruppeModellDML[]>;
    maler: Signal<GruppeModellDML[]>;
    invitertTil: Signal<GruppeInvitasjonTilGodkjenningModell[]>;

    constructor(private avhengigheter: GrupperVisKomponentAvhengigheter, private navigasjon:Navigasjon) {
        const alleGrupper = toSignal(this.avhengigheter.grupper(), {initialValue: []})

        this.ordinaere = computed(() => alleGrupperMedType(alleGrupper(), Gruppetype.ordinær));
        this.maler = computed(() => alleGrupperMedType(alleGrupper(), Gruppetype.mal));
        this.invitertTil = toSignal(this.avhengigheter.invitasjoner(), {initialValue: []});
    }

    nyGruppeOpprettet(nyGruppe: GruppeModell) {
        //kalle async varianten da vi ellers får problemer fordi NavigasjonDeaktivering.reaktiverNavigasjon kjører asynkront
        this.navigasjon.gåTilGruppeAsync(nyGruppe.id);
    }
}

@Injectable()
export class GrupperVisKomponentAvhengigheter {

    constructor(private gruppeDatatjeneste: GruppeDatatjeneste, private invitasjonerDatatjeneste: InvitasjonerDatatjeneste) {
    }

    grupper(): Observable<GruppeModellDML[]> {
        return this.gruppeDatatjeneste.tilgjengeligeGrupper();
    }

    invitasjoner(): Observable<GruppeInvitasjonTilGodkjenningModell[]> {
        return this.invitasjonerDatatjeneste.invitasjonerTilGodkjenning();
    }
}
